<template>
<!-- 拍品 -->
<div class="index page">
    <panel ref="panel" :wapTitle="''" :appLink="'/2/8/0'" :spreadID="'0'" :showNav="false" :isShowNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
    <!-- 搜索头部 -->
    <div class="search_top">
        <form action="/" style="display: flex;align-items: center;background: #fff;">
            <img @click="cancel" class="search_back" src="../../assets/img/Frame585_new@2x.png" alt="">
            <van-search v-model="value" show-action shape="round" background="#FFFFFF" placeholder="书画" @input="pnt" @search="search" @focus="focusValue" @blur="blurValue">
                <template #action>
                    <div @click="search">搜索</div>
                </template>
            </van-search>
        </form>
    </div>
    <div class="wordBox" v-if="focusFlag&&value&&wordList.length>0">
        <template v-for="(item, index) in wordList">
            <div class="sourceWord" :key="index+'sourceWord'" @click="jumpSearch(item)">
                <van-icon name="search" />
                <span v-html="item.source_wordShow"></span>
            </div>
        </template>
    </div>
    <!-- tab页 -->
    <div class="search_tabsmm">
        <!-- search -->
        <div class="tabItem" @click="scFun('35','2','1'),gotoSearch('search')" data-index="0">
            综合
        </div>
        <div class="tabItem active" data-index="1">拍品</div>
        <div class="tabItem" data-index="2" @click="scFun('35','2','3'),gotoSearch('paiacution')">
            拍卖会
        </div>
        <div class="tabItem" data-index="3" @click="scFun('35','2','4'),gotoSearch('company')">
            拍卖公司
        </div>
        <div class="tabItem" data-index="4" @click="scFun('35','2','5'),gotoSearch('market')">
            市场报告
        </div>
        <div class="tabItem" data-index="5" @click="scFun('35','2','6'),gotoSearch('infor')">
            资讯
        </div>
    </div>
    <!-- 在搜索选项有数据的时候显示的页面 -->
    <histor linkName="paipin" v-if="hiss" :nunber="param.type" :water="showWater"></histor>
    <!-- 在搜索没有显示的时候 -->
    <div v-if="!hiss&&!(focusFlag&&value&&wordList.length>0)">
        <div class="select-tab navBar">
            <div ref="compre" @click="comprehensive" class="navItem active">
                综合
            </div>
            <div ref="selection" @click="selectionsive" class="navItem">
                甄选
            </div>
            <div ref="time" @click="sortTime" class="navItem orderItem">
                拍卖时间
            </div>
            <div ref="cheng" @click="sortCheng" class="navItem orderItem">
                成交价
            </div>
            <div ref="gu" @click="sortGu" class="navItem orderItem">
                估价
            </div>
            <div class="select-item" @click="paipinSelect">
                <span>筛选</span>
                <div class="select-icon"></div>
            </div>
        </div>
        <!-- grid -->
        <div class="grid" v-if="loadingIf" :style="{paddingBottom:isVipShow?'3rem':'0'}">
            <van-list v-model="loading" :finished="finished" finished-text="——— 我是有底线的 ———" @load="onLoad">
                <div class="grid-item" v-for="(item, index) in paiList" :key="index" @click="dicengJump(item,index)">
                    <div class="pic">
                        <img :src="item.coverPic" alt="" />
                        <span v-if="item.isHD==1" class="bigFlag"></span>
                        <span class="live" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 2">
                            <lottie class="liveIconSty" :options="heartOptions" :height="0.7" :width="0.7" />直播中
                        </span>
                        <span class="liveReview" v-else>
                            {{ item.date }}
                        </span>
                        <!-- <span class="liveReview" v-else-if="item.live_info.have_live == 1 && item.live_info.live_status == 4 && item.live_info.have_review == 1">直播回放</span> -->
                    </div>
                    <div class="grid-content">
                        <div class="title">
                            <!-- <div class="hot"></div> -->

                            <span class="titSp">

                                <span :class="[
                                            'status',
                                            item.status == 1 ? 'status1' : '',
                                            item.status == 4 ? 'status2' : '',
                                            item.status == 5 ? 'status3' : '',
                                            item.status == 2 ? 'status4' : '',
                                            item.status == 3 ? 'status5' : '',
                                        ]">
                                </span>
                                <span  v-html="hightLight($route.query.searchValue, item.detail.workName)">

                                </span>    
                            </span>
                        </div>
                        <div class="tags" v-if="
                                    item.live_info && item.live_info.label_list
                                ">
                                <template v-for="(k, j) in item.live_info.label_list" >
                                    <template v-if="k.name=='同步拍'">
                                            <img :key="j" class="bidIcon"  src="@/assets/img/bid_type_r.png" alt="">
                                        </template>
                                        <template v-else-if="k.name=='限时拍'">
                                            <img :key="j" class="bidIcon"  src="@/assets/img/bid_type_b.png" alt="">
                                        </template>
                                    <div class="tag" v-else :class="{tagStyle:k.style==1||k.style==5}" :key="j">
                                                {{k.name}}
                                    </div>
                                </template>
                        </div>
                        <div class="grid-list">
                            <div class="left">
                                <ul>
                                    <li>
                                        <span style="margin-left: 0rem;">{{item.company+' '+item.city}}</span>
                                    </li>
                                    <li :class="{'greenText' : item.live_info.have_live == 1 && item.live_info.live_status}">
                                        <template v-if="item.price.needMember==1&&isMem ==1||item.price.needMember!=1">
                                            <div class="labelText" :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.label}}:<i :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.smallText}}</i><span :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.text}}</span></div>
                                            <div  :style="item.price.type=='now_price'?'color:#009B5F':''" class="labelText"><span style="color:#fff">{{item.price.label}}</span><i :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.otherSmallText}}</i><span :style="item.price.type=='now_price'?'color:#009B5F':''">{{item.price.otherText}}</span></div>
                                        </template>
                                        <template v-else>
                                           <div class="labelText">{{item.price.label}}:<i>{{item.price.smallText}}</i><span>{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price'||(item.price.type=='price'&&(item.price.text=='撤拍'||item.price.text=='未提供'||item.price.text=='--')))?item.price.text:'****'}}</span></div>
                                           <div  :style="item.price.type=='now_price'?'color:#009B5F':''" class="labelText"><span style="color:#fff">{{item.price.label}}</span><i :style="item.price.type=='now_price'?'color:#009B5F':''">{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price'||item.price.type=='price')?item.price.otherSmallText:''}}</i><span v-if="item.price.otherSmallText" :style="item.price.type=='now_price'?'color:#009B5F':''">{{(item.price.type=='gujia'||item.price.type=='start_price'||item.price.type=='now_price')?item.price.otherText:'****'}}</span></div>
                                        </template>
                                    </li>

                                </ul>
                            </div>
                            <div v-if="((item.live_info.bid_type==1||item.live_info.bid_type==2)&&item.status!=5)" class="right" @click="gotoApp">
                                <img src="../../assets/img/goSend.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <emptyPage v-else></emptyPage>
    </div>
    <div class="fixBot" v-if="isVipShow">
        <div class="liveBtn">
            <div @click="gotoVip">成为藏家会员查看成交价</div>
        </div>
    </div>
    <share :nunber="param.type"></share>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import histor from "./component/histor.vue";
import {
    lotss,
    getMemType,
    searchWord
} from "@/api/auction";
import emptyPage from "@/components/empty/emptyPage";
import share from "./component/metaComponent.vue";
import DownLoadApp from "@/components/common/downloadApp";
import panel from "@/views/preview/component/panel";
import watermark from "@/components/common/watermark";
import {
    scMdFunc,
    gotoLogin
} from "@/assets/js/scData";
import {
    getApp
} from "@/api/request";
import lottie from '@/components/common/lottie'
const liveIcon = require('../../assets/img/live_icon_2.json')
export default {
    // 拍品 type 2
    data() {
        return {
            showWater: false,
            waterLink: "",
            isMem: 0,
            t: 0,
            loadingIf: true,
            appLink: '/2/8/0',
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            param: {
                type: 2,
                page: 1,
                keyword: "",
                orderby: 0,
                // 筛选的选择项
                status: null,
                startdate: "", //开始时间参数
                enddate: "", //结束时间参数
                rmbPriceStart: null, //开始估价
                rmbPriceEnd: null, //结束估价
                classCode: "", //拍品类别
                organCode: "", //公司
                selection: 0, //甄选标识
                next_page_status: 0, //甄选标识
            },
            value: "", //搜索内容
            hiss: true,
            paiList: [], //拍品列表
            noMore: false, //我是有底线的
            loading: false,
            finished: false,
            //   updown是0的时候后面有三角
            list: [{
                    name: "拍卖时间",
                    updown: 0
                },
                {
                    name: "成交价",
                    updown: 0
                },
                {
                    name: "估价",
                    updown: 1
                },
            ],
            isLogin: false,
            isVipShow: false,
            memberStatus: 0,
            version: 0,
            focusFlag: false,
            wordList: []
        };
    },
    created() {
        this.getMemType()
        this.t = Date.now()
        if (this.$route.query.from) {
            this.showWater = true;
            this.waterLink = "&from=" + this.$route.query.from;
        }
        if (this.$route.query.params && this.$route.query.searchValue) {
            this.param.status = this.$route.query.params.status;
            this.param.startdate = this.$route.query.params.startdate;
            this.param.enddate = this.$route.query.params.enddate;
            this.param.rmbPriceStart = this.$route.query.params.rmbPriceStart;
            this.param.rmbPriceEnd = this.$route.query.params.rmbPriceEnd;
            this.param.classCode = this.$route.query.params.classCode;
            this.param.organCode = this.$route.query.params.organCode;
            this.hiss = false;
            this.value = decodeURIComponent(this.$route.query.searchValue);
            this.getlotss();
            return;
        } else if (this.$route.query.searchValue) {
            this.hiss = false;
            this.value = decodeURIComponent(this.$route.query.searchValue);
            this.getlotss();

        }

    },
    mounted() {
        scMdFunc('vipBenefitsEntryPage', {
            current_page: '拍卖专场详情页'
        });
    },
    methods: {
        hightLight (keyWord, suggtion) {
            // console.log(keyWord, suggtion)
            // 使用 regexp 构造函数，因为这里要匹配的是一个变量
            const reg = new RegExp(decodeURIComponent(keyWord), 'ig')
            //内容段匹配以及添加样式
            const newSrt = String(suggtion).replace(reg, function (p) {
                return "<span style='color: #009B5F'>" + p + '</span>'
            })
            // 返回处理后的值
            return newSrt
        },
        brightKeyword(e) {
            let keyword = e;
            let val = this.value;
            keyword = keyword.trim();
            if (keyword & keyword.length > 0) {
                if (keyword == val) {
                    return '<span>' + val + '</span>'
                }
                keyword = keyword.replaceAll("", "|");
                let reg = new RegExp(keyword, "ig")
                return val.replace(reg, (match) => {
                    return '<span>' + match + '</span>'
                })
            }
        },
        scFun(p = '', m = '', b = '', dataEle) { //新单击埋点
            scMdFunc('allClick', {
                cur_page: p,
                cur_moudle: p + '-' + m,
                cur_button: p + '-' + m + '-' + b,
                ...dataEle
            })
        },
        focusValue() {
            this.focusFlag = true;
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-1',
            })
            searchWord({
                keyword: this.value,
                type: 1
            }).then((res) => {
                if (res.code == 0) {
                    this.wordList = res.data.list
                    this.wordList = this.wordList.map((item) => {
                        let replaceReg = new RegExp(this.value, 'g');
                        let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                        if (item.source_word.includes(this.value)) {
                            item.source_wordShow = item.source_word.replace(replaceReg, replaceContent);
                        } else {
                            item.source_wordShow = item.source_word
                        }
                        return item;
                    });
                }
            })
        },
        blurValue() {
            let that = this;
            setTimeout(() => {
                that.focusFlag = false;

            }, 500)

        },
        jumpSearch(e) {
            this.value = e.source_word;
            this.gotoSearch('paipin');
            // let that = this;
            // switch (e.source_type) {
            //     case 0:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 1:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 2:
            //         that.value=e.source_word;
            //         that.gotoSearch('paipin');
            //         break;
            //     case 3:
            //         that.value=e.source_word;
            //         that.gotoSearch('search');
            //         break;
            //     case 4:
            //         that.value=e.source_word;
            //         that.gotoSearch('paiacution');
            //         break;
            //     case 6:
            //         that.value=e.source_word;
            //         that.gotoSearch('company');
            //         break;
            //     case 7:
            //         that.value=e.source_word;
            //         that.gotoSearch('market');
            //         break;
            //     case 5:
            //         that.value=e.source_word;
            //         that.gotoSearch('infor');
            //         break;
            // }
        },
        getApp() {
            getApp('/source').then((res) => {
                if (res.data.isApp) {
                    this.version = res.data.version
                }
            })
        },
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember;
                    this.memberStatus = res.data.memberStatus;
                    // if (!(res.data.isMember == 1 && res.data.memberStatus == 2) && this.$route.query.searchValue) {
                    //     this.isVipShow = true;
                    // }
                }
            })
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        // 搜索取消
        cancel() {
            // this.$router.push({ path: "/" });
            let url = this.showWater ? "?from=" + this.$route.query.from : "";
            scMdFunc('allClick', {
                cur_page: '35',
                cur_moudle: '35-1',
                cur_button: '35-1-2',
            })
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                window.location.href =
                    "https://m-auction.artron.net/live/" + url;
            } else {
                this.$router.push({
                    path: "/" + url
                });
            }
        },
        // 输入文字搜索功能
        async pnt() {
            if (!this.value) {
                this.hiss = true;
                this.param.page = 1;
                this.paiList = [];
                this.$router.push({
                    name: "paipin",
                    query: {
                        searchValue: "",
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            } else {
                await searchWord({
                    keyword: this.value,
                    type: 1
                }).then((res) => {
                    if (res.code == 0) {
                        this.wordList = res.data.list
                        this.wordList = this.wordList.map((item) => {
                            let replaceReg = new RegExp(this.value, 'g');
                            let replaceContent = '<span style="color:#18BD6F">' + this.value + '</span>';
                            if (item.source_word.includes(this.value)) {
                                item.source_wordShow = item.source_word.replace(replaceReg, replaceContent);
                            } else {
                                item.source_wordShow = item.source_word
                            }
                            return item;
                        });
                    }
                })
            }
        },
        // 点击搜索时触发
        search() {
            this.param.page = 1;
            this.paiList = [];
            if (this.value) {
                // 输入框有值就触发
                this.getlotss();
                // this.$router.push({
                //     name: "paipin",
                //     query: {
                //         searchValue: encodeURIComponent(this.value),
                //         from: this.showWater ? this.$route.query.from : "",
                //     },
                // });
                this.hiss = false;
            }
        },
        // tab切换
        gotoSearch(link) {
            // this.$router.push({
            //     name: link,
            //     query: { searchValue: encodeURIComponent(this.value) },
            // });
            if (
                this.$route.query.searchType &&
                this.$route.query.searchType == "live"
            ) {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        searchType: "live",
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            } else {
                this.$router.push({
                    name: link,
                    query: {
                        searchValue: encodeURIComponent(this.value),
                        from: this.showWater ? this.$route.query.from : "",
                    },
                });
            }
            this.focusFlag = false;
            //   this.$refs.tabDom.children[index].classList.add("active").
        },
        // 跳转到拍品底层
        dicengJump(item, index) {
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-5',
                cur_button: '13-5-' + (Number(index) + 1),
            })
            window.location.href = "https://m-auction.artron.net/trade/auction/detail/" + item.artCode;
            // this.$router.push({
            //     path: "/productdetail/" + item.artCode + this.waterLink,
            // });
        },
        // 跳转筛选页面
        paipinSelect() {
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-6',
            })
            this.$router.push({
                name: "pinselect",
                query: {
                    value: encodeURIComponent(this.value),
                    params: this.param,
                    from: this.showWater ? this.$route.query.from : "",
                },
            });
        },
        // 排序功能
        // 拍卖时间
        sortTime() {
            this.loading = true;
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-3',
            })
            this.param.page = 1;
            //  7成交价升序 6成交价降序  5浏览量降序  4估价升序 3股价降序 2拍卖日期 升序 1拍卖日期降序
            // 调接口
            //   赋值
            this.$refs.time.classList.add("active");
            this.param.orderby == 2 ?
                (this.param.orderby = 1) :
                (this.param.orderby = 2);
            //    添加类名
            if (this.$refs.time.className.includes("up")) {
                this.$refs.time.classList.remove("up");
                this.$refs.time.classList.add("down");
            } else {
                this.$refs.time.classList.remove("down");
                this.$refs.time.classList.add("up");
            }
            this.param.selection = 0;
            this.paiList = [];
            this.getlotss();
            //   去除其他标签的class属性
            this.$refs.cheng.classList.remove("up");
            this.$refs.cheng.classList.remove("down");
            this.$refs.cheng.classList.remove("active");
            this.$refs.gu.classList.remove("active");
            this.$refs.gu.classList.remove("up");
            this.$refs.gu.classList.remove("down");
            this.$refs.compre.classList.remove("active");
            this.$refs.selection.classList.remove("active");
        },
        // 成交价
        sortCheng() {
            this.loading = true;
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-4',
            })
            this.param.page = 1;
            this.$refs.cheng.classList.add("active");
            this.param.orderby == 7 ?
                (this.param.orderby = 6) :
                (this.param.orderby = 7);
            //    添加类名
            if (this.$refs.cheng.className.includes("up")) {
                this.$refs.cheng.classList.remove("up");
                this.$refs.cheng.classList.add("down");
            } else {
                this.$refs.cheng.classList.remove("down");
                this.$refs.cheng.classList.add("up");
            }
            this.param.selection = 0;
            this.paiList = [];
            this.getlotss();
            //   去除其他标签的class属性
            this.$refs.time.classList.remove("up");
            this.$refs.time.classList.remove("down");
            this.$refs.time.classList.remove("active");
            this.$refs.gu.classList.remove("active");
            this.$refs.gu.classList.remove("up");
            this.$refs.gu.classList.remove("down");
            this.$refs.compre.classList.remove("active");
            this.$refs.selection.classList.remove("active");
        },
        // 估价
        sortGu() {
            this.loading = true;
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-5',
            })
            this.param.page = 1;
            this.$refs.gu.classList.add("active");
            this.param.orderby == 4 ?
                (this.param.orderby = 3) :
                (this.param.orderby = 4);
            //    添加类名
            if (this.$refs.gu.className.includes("up")) {
                this.$refs.gu.classList.remove("up");
                this.$refs.gu.classList.add("down");
            } else {
                this.$refs.gu.classList.remove("down");
                this.$refs.gu.classList.add("up");
            }
            this.param.selection = 0;
            this.paiList = [];
            this.getlotss();
            //   去除其他标签的class属性
            this.$refs.cheng.classList.remove("up");
            this.$refs.cheng.classList.remove("down");
            this.$refs.cheng.classList.remove("active");
            this.$refs.time.classList.remove("active");
            this.$refs.time.classList.remove("up");
            this.$refs.time.classList.remove("down");
            this.$refs.compre.classList.remove("active");
            this.$refs.selection.classList.remove("active");
        },
        //甄选
        selectionsive() {
            this.loading = true;
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-2',
            })
            this.param.page = 1;
            this.$refs.selection.classList.add("active");
            this.param.orderby = 0;
            this.param.selection = 1;

            this.paiList = [];
            this.getlotss();
            //   去除其他标签的class属性
            this.$refs.compre.classList.remove("active");
            this.$refs.cheng.classList.remove("up");
            this.$refs.cheng.classList.remove("down");
            this.$refs.cheng.classList.remove("active");
            this.$refs.time.classList.remove("active");
            this.$refs.time.classList.remove("up");
            this.$refs.time.classList.remove("down");
            this.$refs.gu.classList.remove("down");
            this.$refs.gu.classList.remove("up");
            this.$refs.gu.classList.remove("active");
        },
        //综合
        comprehensive() {
            this.loading = true;
            scMdFunc('allClick', {
                cur_page: '13',
                cur_moudle: '13-4',
                cur_button: '13-4-1',
            })
            this.param.page = 1;
            this.$refs.compre.classList.add("active");
            this.param.orderby = 0;
            this.param.selection = 0;

            this.paiList = [];
            this.getlotss();
            //   去除其他标签的class属性
            this.$refs.cheng.classList.remove("up");
            this.$refs.cheng.classList.remove("down");
            this.$refs.cheng.classList.remove("active");
            this.$refs.time.classList.remove("active");
            this.$refs.time.classList.remove("up");
            this.$refs.time.classList.remove("down");
            this.$refs.gu.classList.remove("down");
            this.$refs.gu.classList.remove("up");
            this.$refs.gu.classList.remove("active");
            this.$refs.selection.classList.remove("active");
        },
        // 接口
        getlotss() {
            this.loadingIf = true;
            this.param.keyword = this.value;
            lotss(this.param).then((res) => {
                if (res.code == 0) {
                    this.isLogin = res.data.isLogin
                    this.param.next_page_status=res.data.next_page_status
                    // 埋点
                    if (!res.data.dataList && res.data.morePage != 1) {
                        this.loading = false;
                        this.finished = true;
                    }
                    if (res.data.dataList) {
                        this.paiList = this.paiList.concat(res.data.dataList);
                        if (this.paiList.length == 0) {
                            this.loadingIf = false;
                        }
                        this.loading = false;
                        this.param.page++;
                        if (res.data.morePage == 0) {
                            this.finished = true;
                            this.noMore = true;
                        }
                        for(let i in res.data.dataList){
                            if (!(this.isMem == 1)&&this.isVipShow==false&&res.data.dataList[i].status==5) {
                                this.isVipShow = true;
                            }
                        }
                          
                    }
                }
            });
        },
        onLoad() {
            if (this.param.page >= 2) {
                this.getlotss();
            }
        },
        gotoVip() {
            let bridge = window.WebViewJavascriptBridge;
            let isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
            let isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
            scMdFunc('clickVip', {
                current_page: '拍卖专场详情页',
                button_name: '成为藏家会员查看成交价'
            });
            if (this.isLogin == 0) {
                gotoLogin()
            } else {
                if (!(this.isMem == 1 && this.memberStatus == 2)) {
                    if (bridge && isTuluApp || bridge && isToutiaoApp) {
                        if (isToutiaoApp) {
                            if (this.version >= 464000) {
                                bridge.callHandler('appGotoRightsMembers', {
                                    index: 0,
                                    source_page: '拍卖专场详情页',
                                    source_module: '成为藏家会员查看成交价'
                                }, function () {})
                            } else {
                                bridge.callHandler('appGotoRightsMembers', {
                                    index: 0
                                }, function () {})
                            }
                        } else {
                            if (this.version >= 1061203) {
                                bridge.callHandler('appOpenMemberPay', {
                                    source_page: '拍卖专场详情页',
                                    source_module: '成为藏家会员查看成交价'
                                }, function () {})
                            } else {
                                bridge.callHandler('appOpenMemberPay', {}, function () {})
                            }
                        }
                    } else {
                        window.location.href = 'http://tulu.artron.net/wap/share/member' + "?from=" + encodeURIComponent(location.href);
                    }
                }
            }
        }
    },
    components: {
        histor,
        emptyPage,
        share,
        DownLoadApp,
        lottie,
        panel,
        watermark,
    },
};
</script>

<style lang="scss" scoped>
// 搜索头部和tab页面
.bigFlag{position: absolute;background:url("../../assets/img/Frame741@2x.png") no-repeat;width:1.6rem;height:1.6rem;background-size: 100%;right:0;top:0;}
/deep/ .van-search__content {
    background-color: #f3f3f3;

    .van-icon-search::before {
        content: ''
    }

    .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
        background: url("../../assets/img/icon_auc_search.png") no-repeat center;
        background-size: .7rem auto;
        width: .7rem;
    }
}

/deep/.van-search__action {
    padding: 0 .4rem;
    font-size: .85rem;
    color: #969696;
}

.search_back {
    width: 2rem;
    display: inline-block;
}

/deep/.van-search {
    width: calc(100% - 2rem);
    padding-left: 0;
}

.liveIconSty {
    display: inline-block;
    vertical-align: middle;
    background: #F6344B;
    border-radius: 0.7rem;
    margin-right: 0.2rem;
    padding: 0.2rem;
}


.wordBox {
    position: absolute;
    top: 5rem;
    left: 0;
    background: #fff;
    width: 100%;
    z-index: 9;
    min-height: calc(100vh - 6rem);

    .sourceWord {
        width: calc(100% - 1.2rem);
        margin: 0.3rem 0.6rem;
        padding: 0.3rem 0;
        font-size: 0.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);

        i {
            font-size: 1rem;
            vertical-align: middle;
            margin-right: 0.2rem;
        }
    }
}

.tabItem:last-child {
    padding-right: 0.9rem;
}

.search_tabsmm::-webkit-scrollbar {
    display: none;
}

.search_tabsmm {
    display: flex;
    display: -webkit-box;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    padding: 0 0.75rem;
    width: 18.75rem;
    height: 1.8rem;
    background-color: #fff;
    align-items: center;
    position: relative;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
}

.search_tabsmm:after {
    display: block;
    height: .05rem;
    width: 150%;
    position: absolute;
    bottom: .025rem;
    background-color: #dddee3;
    content: '';
    left: 0;
}

.search_tabsmm .tabItem {
    margin-right: 0.7rem;
    line-height: 1.8rem;
    height: 1.8rem;
}

.search_tabsmm .tabItem.active {
    color: #18bd6f;
    border-bottom: 0.15rem solid #18bd6f;
    position: relative;
    z-index: 1;
}

// 底部
// 。筛选
.navBar {
    height: 1.75rem;
    padding-left: 1.15rem;
    padding-right: 0.9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
}

.navBar .navItem {
    font-size: 0.7rem;
    color: #27282d;
    line-height: 1.75rem;
    position: relative;
}

.navBar .orderItem {
    padding-right: 0.6rem;
}

.navBar .orderItem::before {
    content: "";
    position: absolute;
    width: 0.3rem;
    height: 0.3rem;
    right: 0;
    top: 0.55rem;
    background: url(../../assets/img/grey_up.png) no-repeat;
    background-size: cover;
}

.navBar .orderItem::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0.55rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url(../../assets/img/grey_down.png) no-repeat;
    background-size: cover;
}

.navBar .active {
    color: #35bd7d;
}

.navBar .up::before {
    background-image: url(../../assets/img/green_up.png);
}

.navBar .down::after {
    background-image: url(../../assets/img/green_down.png);
}

/* 拍卖中 */
.auction {
    width: 18.75rem;
}

.auction-item {
    /* padding: 0.75rem; */
    background-color: #fff;
    margin-bottom: 0.25rem;
}

.auction-item .item-top {
    display: flex;
    // align-items: center;
    padding: 0.75rem 0.75rem 0 0.75rem;
}

.auction-item .item-icon {
    width: 1.9rem;
    height: 0.7rem;
    background-image: url(../../assets/img/icon_list_tag_red@2x.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.tagStyle {
    color: #FFFFFF !important;
    border: 0;
    background: linear-gradient(87deg, #FB9C57 0%, #F22C2C 100%), rgba(0, 155, 95, 0.05) !important;
}

.auction-item .txt {
    width: 15.25rem;
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.1rem;
    margin-left: 0.1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.auction-item .txt span {
    color: #18bd6f;
}

.auction-item .item-brief {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 0.5rem;
    padding: 0 0.75rem 0 0.75rem;
}

.item-brief .brief {
    display: flex;
    align-items: center;
}

.bidIcon {
    height: 16px;
    margin-right: 0.5rem;
}

.item-brief .brief span {
    /* width: 7.8rem; */
    height: 0.9rem;
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;
}

.item-brief .brief-icon {
    width: 0.65rem;
    height: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.3rem;
}

.item-brief .brief-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.auction-item .play {
    width: 10.4rem;
    /* height: 6.25rem; */
    border-radius: 0.15rem;
    /* border: 0.05rem solid #DDDEE3; */
    margin-top: 0.5rem;
    display: flex;
    padding: 0 0.75rem 0.75rem 0.75rem;
}

.play .play-left {
    width: 4.75rem;
    height: 6.25rem;
}

.play-left .pic {
    position: relative;
    border-radius: 0.15rem 0rem 0rem 0.15rem;
    width: 4.75rem;
    height: 6.25rem;
    background-image: url(../../assets/img/xinyang.webp);
    background-repeat: no-repeat;
    background-position: center;
    /* background-size: cover; */
}

.status {
    width: 1.9rem;
    height: 0.9rem;
    margin-right: 0.2rem;
    margin-top: 0.2rem;
    display: inline-block;
    vertical-align: -0.1rem;
    margin-right: 0.2rem;
}

.status1 {
    background: url(../../assets/img/stats2.png) no-repeat;
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status2 {
    background: url(../../assets/img/stats1.png) no-repeat;
    background-color: rgba(235, 81, 100, 0.10);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status3 {
    background: url(../../assets/img/stats3.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.status4 {
    background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
    background-color: rgba(54, 153, 114, 0.10);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}

.status5 {
    background: url(../../assets/img/stats3.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 100%;
    height: 0.8rem;
}

.play-left .pic .tip {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 4.75rem;
    height: 1.1rem;
    background: rgba(255, 95, 0, 0.9);
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.9rem;
    border-radius: 0 0 0 0.15rem;
}

.tip .line {
    width: 0.44rem;
    height: 0.5rem;
    margin-left: 0.7rem;
    margin-right: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.line .first-line {
    width: 0.05rem;
    height: 0.3rem;
    background-color: #fff;
}

.line .second-line {
    width: 0.05rem;
    height: 0.15rem;
    background-color: #fff;
}

.line .third-line {
    width: 0.05rem;
    height: 0.4rem;
    background-color: #fff;
}

.line .forth-line {
    width: 0.05rem;
    height: 0.2rem;
    background-color: #fff;
}

.play .play-right {
    width: 5.75rem;
    height: 6.25rem;
    background: rgba(216, 216, 216, 0);
    border-radius: 0rem 0.15rem 0.15rem 0rem;
    border: 0.05rem solid #dddee3;
    border-left: none;
    display: flex;
    flex-direction: column;
}

.play .play-right .play-content {
    width: 4.7rem;
    height: 1.8rem;
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;
    margin: 0.45rem 0.5rem 0.2rem 0.55rem;
}

.play-right .play-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0.5rem 0 0.55rem;
}

.play-right .play-tips .play-tip:nth-child(1) {
    width: 2.4rem;
    height: 0.7rem;
}

.play-right .play-tips .play-tip:nth-child(2) {
    width: 1.9rem;
    height: 0.7rem;
}

.play-tips .play-tip img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 轮播 */
.play-swiper {
    /* width: 18.75rem; */
    width: 18rem;
    margin-top: 0.5rem;
    /* padding-right: -1.75rem; */
    margin-left: 0.75rem;
    padding-bottom: 0.75rem;
}

.play-swiper .swiper-wrapper {
    width: 18rem;
}

.play-swiper .swiper-wrapper .swiper-slide {
    width: 4.75rem;
    border-radius: 0.2rem;
    margin-right: 0.4rem;
    /* position: relative; */
    display: flex;
    flex-direction: column;
}

.swiper-wrapper .swiper-slide .slide-pic {
    width: 4.75rem;
    height: 6.25rem;
    border-radius: 0.2rem;
    position: relative;
}

.swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
    border-radius: 0.2rem;
}

.swiper-wrapper .swiper-slide .collection {
    position: absolute;
    bottom: 0.2rem;
    right: 0.2rem;
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.6);
}

.swiper-wrapper .swiper-slide .tip {
    position: absolute;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 4.75rem;
    height: 1.1rem;
    background: rgba(255, 95, 0, 0.9);
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.9rem;
    border-radius: 0 0 0.15rem 0.15rem;
}

.tip .line {
    width: 0.44rem;
    height: 0.5rem;
    margin-left: 0.7rem;
    margin-right: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.line .first-line {
    width: 0.05rem;
    height: 0.3rem;
    background-color: #fff;
}

.line .second-line {
    width: 0.05rem;
    height: 0.15rem;
    background-color: #fff;
}

.line .third-line {
    width: 0.05rem;
    height: 0.4rem;
    background-color: #fff;
}

.line .forth-line {
    width: 0.05rem;
    height: 0.2rem;
    background-color: #fff;
}

.swiper-slide .slide-name {
    margin-top: 0.4rem;
    width: 4.75rem;
    height: 1.8rem;
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;
}

.swiper-slide .slide-tips {
    display: flex;
    margin-top: 0.2rem;
}

.slide-tips .slide-tip {
    display: flex;
    align-items: center;
    justify-content: center;
}

.slide-tips .slide-tip:nth-child(1) {
    width: 2.4rem;
    height: 0.7rem;
    margin-right: 0.3rem;
}

.slide-tips .slide-tip:nth-child(2) {
    width: 1.9rem;
    height: 0.7rem;
}

.slide-tips .slide-tip img {
    width: 100%;
    height: 100%;
}

.select-tab {
    width: 18.75rem;
    height: 2.1rem;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.65rem;
    border-bottom: .05rem solid #DDDEE3;
}

.select-tab .select-item {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    display: flex;
    align-items: center;
}

.select-tab .select-item span {
    margin-right: 0.3rem;
}

.select-tab .select-item span.active {
    color: #18bd6f;
}

.select-tb .select-top.active {
    border-color: transparent transparent #18bd6f;
}

.select-item .select-icon {
    width: 0.65rem;
    height: 0.65rem;
    /* background: rgba(255, 255, 255, 0.01); */
    background-image: url(../../assets/img/screen.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

/* grid */
.grid {
    width: 18.75rem;
    background-color: #ffffff;
    padding: 0 0.75rem;
    margin-bottom: 2.4rem;
    padding-bottom: 3rem;
}

.grid .grid-item {
    width: 17.25rem;
    padding-bottom: .75rem;
    border-bottom: 0.05rem solid #dddee3;
    padding-top: 0.75rem;
    display: flex;
}

.grid-item .pic {
    width: 5rem;
    height: 5rem;
    border-radius: 0.4rem;
    position: relative;
    overflow: hidden;
    background: #D9D9D9;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .live {
        position: absolute;
        bottom: 0;
        left: 50%;
        border-radius: 1rem;
        width: 3.2rem;
        height: 1.4rem;
        line-height: 3;
        transform: translate(-50%, -20%);
        background: rgba(255, 255, 255, 0.9);
        text-align: center;
        font-size: 0.45rem;
        color: #000000;
    }

    .liveReview {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2rem;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
        font-size: 0.55rem;
        line-height: 3rem;
        color: #ffffff;
        text-align: center;
    }
}

.grid-item .grid-content {
    // margin-left: 0.5rem;
    border-left: 0.5rem solid transparent;
    width: calc(100% - 3.75rem);
}

.grid-content .title {
    line-height: 1.05rem;
    font-size: .8rem;
    color: #27282d;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 2.1rem;
}

.grid-content .title .titSp {
    // width: 2.95rem;
    font-weight: 600;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.grid-content .title .green {
    color: #18bd6f;
}

.tags {
    display: flex;
    margin-top: 0.5rem;
}

.tags .tag {
    padding: 0 0.2rem;
    height: 0.8rem;
    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    margin-right: .5rem;
    font-size: 0.5rem;
    font-family: SF Pro-Regular, SF Pro;
    font-weight: 400;
    color: #6B6C6C;

}

.grid-list {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.grid-list .left li {
    margin-bottom: 0.15rem;
    line-height: .9rem;

}

.grid-list .labelText {
    font-weight: 400;
    font-size: 13px;
    color: #949596;

    span,
    i {
        font-weight: bolder;
        color: #000000;
    }
}

.grid-list .valueText {
    font-weight: 600;
    font-size: 13px;
    color: #000000;
}

.greenText {
    color: #009B5F;
}

.grid-list .left li:last-child {
    margin-bottom: 0;
}

.left li span {
    font-size: 0.65rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 0.8rem;
    margin-left: 0.15rem;
}

.left li .red {
    color: #e93b3d;
}

.left li .smallred {
    color: #e93b3d;
    font-size: 0.55rem;
    margin-left: -0.03rem;
}

.grid-list .left .icon {
    width: 0.65rem;
    height: 0.65rem;
    display: inline-block;
    font-size: 0;
    line-height: 0;
    vertical-align: .3rem;
}

.left .icon img {
    width: 100%;
    height: 100%;
}

.grid-list .right {
    width: 2rem;

    img {
        width: 100%;
    }
}

.fixBot {
    position: fixed;
    width: 18.75rem;
    height: 3rem;
    left: 50%;
    margin-left: -9.375rem;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
}

.fixBot .liveBtn {
    width: 17.25rem;
    height: 2.2rem;
    margin: 0.4rem auto;
    background: #18bd6f;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    border-radius:2rem;
    text-align: center;
    line-height: 2.2rem;
    font-size: 0.8rem;
    line-height: 2.2rem;
    color: #ffffff;

    a {
        color: #fff;
    }
}
</style>
